import React, { Component } from "react";

export class LoadScreen extends Component {
  render() {
    return (
      <div className="ui-g-12">
        <div className="splash-screen" style={{ background: "white" }}>
          <div
            className="splash-container"
            style={{ paddingTop: "10em", paddingBottom: "10em" }}
          >
            <div>
              <img
                src="/assets/layout/images/bpp/bpp-logo.png"
                alt=""
                style={{
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: "99%"
                }}
              />
            </div>
            <div className="load-bar">
              <div className="bar" />
              <div className="bar" />
              <div className="bar" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/LoadScreen.js